import { Area } from '@src/main/modules/common/area/domain/Area';
import { TokenProvider, api } from '@src/main/modules/common/common/infrastructure/http/axios';
import { Dashboard, DashboardCreate } from '@src/main/modules/common/dashboard/domain/Dashboard';
import { DashboardRepository } from '@src/main/modules/common/dashboard/domain/DashboardRepository';
import {
  DashboardResponse,
  mapFromResponseToDomain,
} from '@src/main/modules/common/dashboard/infrastructure/DashboardResponse';

export const createDashboardHttpRepository = (tokenProvider: TokenProvider): DashboardRepository =>
  new DashboardHttpRepository(tokenProvider);

class DashboardHttpRepository implements DashboardRepository {
  private readonly tokenProvider: TokenProvider;

  constructor(tokenProvider: TokenProvider) {
    this.tokenProvider = tokenProvider;
  }

  async findAll(areas: Area[]): Promise<Dashboard[]> {
    const token = await this.tokenProvider.getToken();
    const response = await api.get<DashboardResponse[]>('/dashboard', token);
    return mapFromResponseToDomain(response, areas);
  }

  async put(dashboard: DashboardCreate): Promise<void> {
    const token = await this.tokenProvider.getToken();
    await api.put(`/dashboard/${dashboard.id}`, token, dashboard);
  }

  async delete(dashboardId: string): Promise<void> {
    const token = await this.tokenProvider.getToken();
    await api.delete(`/dashboard/${dashboardId}`, token);
  }
}
